const PERMISSION_LEVELS = {
    UNVERIFIED: 0,
    ADMIN: 2,
    CAMPAIGN_ADMIN: 3,
    VIEWER: 4,
    INSIGHT_VIEWER: 5,
    VIRTUAL_TERMINAL_OPERATOR: 6
}

const MODULE_NAMES = {
    DASHBOARD: 'dashboard',
    CAMPAIGN_LIST: 'campaign_list',
    CAMPAIGN_ADD: 'campaign_add',
    CAMPAIGN_EDIT: 'campaign_edit',
    CAMPAIGN_VIEW: 'campaign_view',
    CAMPAIGN_VIEW_CHANGE_STATUS: 'campaign_view_change_status',
    CAMPAIGN_DONATIONS: 'campaign_donations',
    CAMPAIGN_DESIGNATION: 'campaign_designation',
    CAMPAIGN_DISTRIBUTION: 'campaign_distribution',
    DONATIONS: 'donations',
    DONATIONS_VIEW: 'donations_view',
    CAMPAIGN_DESIGNATION_ADD: 'campaign_designation_add',
    CAMPAIGN_DESIGNATION_EDIT: 'campaign_designation_edit',
    CAMPAIGN_QUESTION: 'campaign_question',
    CAMPAIGN_QUESTION_ADD: 'campaign_question_add',
    CAMPAIGN_QUESTION_EDIT: 'campaign_question_edit',
    CAMPAIGN_DISTRIBUTION_ADD: 'campaign_distribution_add',
    CAMPAIGN_DISTRIBUTION_EDIT: 'campaign_distribution_edit',
    CAMPAIGN_ADD_MANUAL_DONATION: 'campaign_add_manual_donation',
    CAMPAIGN_VIEW_MANUAL_DONATION: 'campaign_view_manual_donation',
    DESIGNATION_LIST: 'designation_list',
    DESIGNATION_ADD: 'designation_add',
    DESIGNATION_EDIT: 'designation_edit',
    DESIGNATION_DONATION: 'designation_donation',
    ACCOUNT: 'account',
    CAMPAIGN_DESIGNATION_DONATIONS: 'campaign_designation_donations',
    USER_MANAGEMENT: 'user_management',
    WIDGET_MANAGEMENT: 'widget_management',
    WIDGET_MANAGEMENT_ADD: 'widget_management_add',
    WIDGET_MANAGEMENT_EDIT: 'widget_management_edit',
    DONATION_LIST: 'donation_list',
    DONATION_STOP_SUBSCRIPTION: 'donation_stop_subscription',
    SUPPORTERS_LIST: 'supporters_list',
    SUPPORTERS_SEND_RECEIPT: 'supporters_send_receipt',
}

const PERMISSION_LEVELS_MODULE_ASSIGNMENTS = {
    [PERMISSION_LEVELS.ADMIN]: [
        MODULE_NAMES.DASHBOARD,
        MODULE_NAMES.CAMPAIGN_LIST,
        MODULE_NAMES.CAMPAIGN_ADD,
        MODULE_NAMES.CAMPAIGN_EDIT,
        MODULE_NAMES.CAMPAIGN_VIEW,
        MODULE_NAMES.CAMPAIGN_VIEW_CHANGE_STATUS,
        MODULE_NAMES.CAMPAIGN_DONATIONS,
        MODULE_NAMES.CAMPAIGN_DESIGNATION,
        MODULE_NAMES.CAMPAIGN_DISTRIBUTION,
        MODULE_NAMES.DONATIONS,
        MODULE_NAMES.DONATIONS_VIEW,
        MODULE_NAMES.CAMPAIGN_DESIGNATION_ADD,
        MODULE_NAMES.CAMPAIGN_DESIGNATION_EDIT,
        MODULE_NAMES.CAMPAIGN_DISTRIBUTION_ADD,
        MODULE_NAMES.CAMPAIGN_DISTRIBUTION_EDIT,
        MODULE_NAMES.CAMPAIGN_ADD_MANUAL_DONATION,
        MODULE_NAMES.CAMPAIGN_VIEW_MANUAL_DONATION,
        MODULE_NAMES.ACCOUNT,
        MODULE_NAMES.DESIGNATION_LIST,
        MODULE_NAMES.DESIGNATION_ADD,
        MODULE_NAMES.DESIGNATION_EDIT,
        MODULE_NAMES.DESIGNATION_DONATION,
        MODULE_NAMES.USER_MANAGEMENT,
        MODULE_NAMES.CAMPAIGN_DESIGNATION_DONATIONS,
        MODULE_NAMES.USER_MANAGEMENT,
        MODULE_NAMES.CAMPAIGN_QUESTION,
        MODULE_NAMES.CAMPAIGN_QUESTION_ADD,
        MODULE_NAMES.CAMPAIGN_QUESTION_EDIT,
        MODULE_NAMES.WIDGET_MANAGEMENT,
        MODULE_NAMES.WIDGET_MANAGEMENT_ADD,
        MODULE_NAMES.WIDGET_MANAGEMENT_EDIT,
        MODULE_NAMES.DONATION_LIST,
        MODULE_NAMES.DONATION_STOP_SUBSCRIPTION,
        MODULE_NAMES.SUPPORTERS_LIST,
        MODULE_NAMES.SUPPORTERS_SEND_RECEIPT,
    ],
    [PERMISSION_LEVELS.CAMPAIGN_ADMIN]: [
        MODULE_NAMES.DASHBOARD,
        MODULE_NAMES.CAMPAIGN_LIST,
        MODULE_NAMES.CAMPAIGN_ADD,
        MODULE_NAMES.CAMPAIGN_EDIT,
        MODULE_NAMES.CAMPAIGN_VIEW,
        MODULE_NAMES.CAMPAIGN_VIEW_CHANGE_STATUS,
        MODULE_NAMES.CAMPAIGN_DONATIONS,
        MODULE_NAMES.CAMPAIGN_DESIGNATION,
        MODULE_NAMES.CAMPAIGN_DISTRIBUTION,
        MODULE_NAMES.DONATIONS,
        MODULE_NAMES.DONATIONS_VIEW,
        MODULE_NAMES.CAMPAIGN_DESIGNATION_ADD,
        MODULE_NAMES.CAMPAIGN_DESIGNATION_EDIT,
        MODULE_NAMES.CAMPAIGN_DISTRIBUTION_ADD,
        MODULE_NAMES.CAMPAIGN_DISTRIBUTION_EDIT,
        MODULE_NAMES.CAMPAIGN_ADD_MANUAL_DONATION,
        MODULE_NAMES.CAMPAIGN_VIEW_MANUAL_DONATION,
        MODULE_NAMES.DESIGNATION_LIST,
        MODULE_NAMES.DESIGNATION_ADD,
        MODULE_NAMES.DESIGNATION_EDIT,
        MODULE_NAMES.DESIGNATION_DONATION,
        MODULE_NAMES.ACCOUNT,
        MODULE_NAMES.CAMPAIGN_DESIGNATION_DONATIONS,
        MODULE_NAMES.CAMPAIGN_QUESTION,
        MODULE_NAMES.CAMPAIGN_QUESTION_ADD,
        MODULE_NAMES.CAMPAIGN_QUESTION_EDIT,
        MODULE_NAMES.WIDGET_MANAGEMENT,
        MODULE_NAMES.WIDGET_MANAGEMENT_ADD,
        MODULE_NAMES.WIDGET_MANAGEMENT_EDIT,
        MODULE_NAMES.DONATION_LIST,
        MODULE_NAMES.DONATION_STOP_SUBSCRIPTION,
        MODULE_NAMES.SUPPORTERS_LIST,
        MODULE_NAMES.SUPPORTERS_SEND_RECEIPT,
    ],
    [PERMISSION_LEVELS.VIEWER]: [
        MODULE_NAMES.DASHBOARD,
        MODULE_NAMES.CAMPAIGN_LIST,
        MODULE_NAMES.CAMPAIGN_VIEW,
        MODULE_NAMES.CAMPAIGN_DONATIONS,
        MODULE_NAMES.CAMPAIGN_DESIGNATION,
        MODULE_NAMES.CAMPAIGN_DISTRIBUTION,
        MODULE_NAMES.DONATIONS,
        MODULE_NAMES.DONATIONS_VIEW,
        MODULE_NAMES.CAMPAIGN_DESIGNATION_DONATIONS,
        MODULE_NAMES.DESIGNATION_LIST,
        MODULE_NAMES.DESIGNATION_DONATION,
        MODULE_NAMES.ACCOUNT,
        MODULE_NAMES.CAMPAIGN_QUESTION,
        MODULE_NAMES.WIDGET_MANAGEMENT,
        MODULE_NAMES.DONATION_LIST,
        MODULE_NAMES.SUPPORTERS_LIST,
    ],
    [PERMISSION_LEVELS.INSIGHT_VIEWER]: [
        MODULE_NAMES.DASHBOARD,
        MODULE_NAMES.ACCOUNT,
    ],
    [PERMISSION_LEVELS.VIRTUAL_TERMINAL_OPERATOR]: [
        MODULE_NAMES.ACCOUNT,
        MODULE_NAMES.CAMPAIGN_LIST,
        MODULE_NAMES.CAMPAIGN_VIEW_MANUAL_DONATION,
    ],
    [PERMISSION_LEVELS.UNVERIFIED]: [
        MODULE_NAMES.ACCOUNT,
    ]
}

const ROUTE_AFTER_LOGIN = {
    [PERMISSION_LEVELS.ADMIN]: '/dashboard',
    [PERMISSION_LEVELS.CAMPAIGN_ADMIN]: '/dashboard',
    [PERMISSION_LEVELS.VIEWER]: '/dashboard',
    [PERMISSION_LEVELS.INSIGHT_VIEWER]: '/dashboard',
    [PERMISSION_LEVELS.VIRTUAL_TERMINAL_OPERATOR]: '/account',
}

const getRouteAfterLogin = (permission_level) => {
    return typeof ROUTE_AFTER_LOGIN[permission_level] !== 'undefined' ? ROUTE_AFTER_LOGIN[permission_level] : '/dashboard'
}

const isAllowedAccess = (permission_level, module_name) => {
    return typeof PERMISSION_LEVELS_MODULE_ASSIGNMENTS[permission_level] !== 'undefined'
        ? PERMISSION_LEVELS_MODULE_ASSIGNMENTS[permission_level].includes(module_name)
        : PERMISSION_LEVELS_MODULE_ASSIGNMENTS[0].includes(module_name) ;
}

const Authorizations = {
    PERMISSION_LEVELS,
    MODULE_NAMES,
    ROUTE_AFTER_LOGIN,
    isAllowedAccess,
    getRouteAfterLogin
}

export default Authorizations
